var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.9678V19.9678C17 18.9069 16.5786 17.8895 15.8284 17.1393C15.0783 16.3892 14.0609 15.9678 13 15.9678H5C3.93913 15.9678 2.92172 16.3892 2.17157 17.1393C1.42143 17.8895 1 18.9069 1 19.9678V21.9678M23 21.9678V19.9678C22.9993 19.0815 22.7044 18.2205 22.1614 17.5201C21.6184 16.8196 20.8581 16.3193 20 16.0978M16 4.09777C16.8604 4.31807 17.623 4.81847 18.1676 5.52008C18.7122 6.22169 19.0078 7.0846 19.0078 7.97277C19.0078 8.86094 18.7122 9.72385 18.1676 10.4255C17.623 11.1271 16.8604 11.6275 16 11.8478M13 7.96777C13 10.1769 11.2091 11.9678 9 11.9678C6.79086 11.9678 5 10.1769 5 7.96777C5 5.75863 6.79086 3.96777 9 3.96777C11.2091 3.96777 13 5.75863 13 7.96777Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.a293ef893d293c70f0a6118c382da62b.svg";
export { ForwardRef as ReactComponent };